module.exports = __webpack_public_path__ + "img/fire_tool_4.6fb719e4.png";